import { Col,Row } from "antd";
import React from "react";

import Heading from "../ProductHeading";
import ProductOverviewDescription from "./ProductOverviewDescription";
import styles from './style.module.scss';

const ProductOverview = ({ product }) => {
  
  return (
    <>
      <Heading text={`Tổng quan về ${product.title}`} />
      <div className={styles["product-overview"]}>
        <div className={styles["card"]}>
          <div className={styles["excerpt"]}>{product.product_analysis_description}</div>
          <Row type="flex" gutter={24}>
            {product.acf.product_analysis_overview_info.map((item, index) =>
              item.layout_width === "100" ? (
                <Col span={24} key={index}>
                  <h3 className={styles["large-title"]}>{item.overview_info_title}</h3>
                  <ProductOverviewDescription
                    index={index}
                    content={item.overview_info_description}
                  />
                </Col>
              ) : (
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} key={index}>
                  <h4 className={styles["small-title"]}>{item.overview_info_title}</h4>
                  <ProductOverviewDescription
                    index={index}
                    content={item.overview_info_description}
                  />
                </Col>
              )
            )}
          </Row>
        </div>
      </div>
    </>
  );
};
export default ProductOverview;
